
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";
import { TranslatePipe } from '@ngx-translate/core';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { LoginService } from '@services/login.service';
import { BaseModal } from './base-modal';

@Component({
    selector: 'logout-modal',
    template: `
        <div class="modal-body">
          @if (!isMandatoryLogout) {
            <button class="close" style='border: none; background-color: transparent;' (click)="closeAndDestroy()">
              <i class="fa-light fa-xmark"></i>
            </button>
          }
          <div class="log-out">
            @if (!isMandatoryLogout) {
              <h3 class="text-center">{{ "HOMEFUNCTIONS.LOGOUTHEADING" | translate }}</h3>
            }
            @if (isMandatoryLogout) {
              <h3 class="text-center">{{ "HOMEFUNCTIONS.MANDATORYLOGOUTHEADING" | translate }}</h3>
            }
            @if (isMandatoryLogout) {
              <p class="text-center" [innerHTML]="'HOMEFUNCTIONS.MANDATORYLOGOUT' | translate"></p>
            }
            <div class="form-group text-center">
              @if (!isMandatoryLogout) {
                <button class="btn btn-secondary mr-3" (click)="closeAndDestroy()">{{ "COMMON.CANCEL" | translate }}</button>
              }
              <button class="btn btn-primary" (click)="logOut()">{{ "HOMEFUNCTIONS.LOGOUT" | translate }}</button>
            </div>
          </div>
        </div>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class LogOutComponent extends BaseModal {

	public isMandatoryLogout: boolean;

	constructor(
		protected router: Router,
		protected loginService: LoginService,
		breadCrumbService: BreadcrumbService
	) {
		super(breadCrumbService);
	}

	async logOut() {
		await this.loginService.Logout();
		location.href = location.origin + "/login";
		this.closeAndDestroy();
	}

}
